import React from 'react';
import { useState } from "react";
import "./install-package.css";
import Close from "../../assets/svg/Close.svg";
import SMLogo from "../../assets/svg/SMLogo.svg";

const InstallPackageData = {
    "appname": process.env.REACT_APP_NAME,
    "publisher": process.env.REACT_APP_PUBLISHER,
    "version": process.env.REACT_APP_VERSION,
    "release_notes": process.env.REACT_APP_RELEASE_NOTES,
}

const dataCenters = [
    { name: "United States", value: "US" },
    { name: "Europe", value: "EU" },
    { name: "Australia", value: "AUS" }
];

export default function InstallDialog() {
    // eslint-disable-next-line no-unused-vars
    const [open, setOpen] = useState(true);
    const [isSandbox, setIsSandbox] = useState(false);
    const [dataCenter, setDataCenter] = useState('US');

    const handleSandboxChange = (event) => {
        const sandboxChecked = event.target.checked;
        setIsSandbox(sandboxChecked);
    };

    const handleChangeDataCenter = (center) => {
        setDataCenter(center);
        console.log("Data Center -------->", center);
    };

    const handleClose = () => {
        setOpen(false);
        window.history.back();
    }

    const onCreateSSOURL = (socialProvider, action) => {
        var ssoUrl = '';
        let SALESFORCE_CONFIG;
        let rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG;
        // eslint-disable-next-line eqeqeq
        if (dataCenter == "US") {
            console.log("In US Data Center");
            rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG_US;
            // eslint-disable-next-line eqeqeq
        } else if (dataCenter == "EU") {
            console.log("In EU Data Center");
            rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG_EU;
            // eslint-disable-next-line eqeqeq
        } else if (dataCenter == "AUS") {
            console.log("In AUS Data Center");
            rawConfig = process.env.REACT_APP_SALESFORCE_CONFIG_AUS;
        }
        try {
            // eslint-disable-next-line no-useless-escape
            const decodedConfig = rawConfig.replace(/\\\"/g, '"').replace(/\\\\/g, '\\');
            SALESFORCE_CONFIG = JSON.parse(decodedConfig);
        } catch (error) {
            alert('Something went wrong')
            console.error("Error parsing SALESFORCE_CONFIG:", error);
            window.history.back();
            return;
        }
        const prod = SALESFORCE_CONFIG.salesforceProd;
        const sandbox = SALESFORCE_CONFIG.salesforceSandbox;
        const state = `org_type=${socialProvider}&source=app_exchange&dataCenter=${dataCenter}&action=${action}`;
        console.log("state in sso url is-------->", state);

        if (socialProvider === 'production') {
            ssoUrl = `${prod.oauth2Endpoint}?response_type=${prod.params.response_type}&client_id=${encodeURIComponent(prod.params.client_id)}&redirect_uri=${encodeURIComponent(prod.params.redirect_uri)}&&state=${encodeURIComponent(state)}`;
        } else {
            ssoUrl = `${sandbox.oauth2Endpoint}?response_type=${sandbox.params.response_type}&client_id=${encodeURIComponent(sandbox.params.client_id)}&prompt=login&redirect_uri=${encodeURIComponent(sandbox.params.redirect_uri)}&state=${encodeURIComponent(state)}`;
        }
        window.parent.location.href = ssoUrl;
    }

    return (
        <div className="dialog">
            <div className="dialog-header-new">
                <div className="close-container">
                    <button className="close-button" onClick={handleClose}>
                        <img src={Close} className="close-icon" alt="Close" />
                    </button>
                </div>
                <div>
                    <div className="dialog-content">
                        <div className="dialog-header">
                            <div className="logo-container-install">
                                <img
                                    src={SMLogo}
                                    alt="SMS Magic Logo"
                                    className="logo"
                                />
                            </div>
                            <div className="dialog-title-container">
                                <h2 className="dialog-title">Install SMS Magic & Conversive | Conversational <br /> Messaging</h2>
                                <p className="dialog-description">By SMS Magic</p>
                            </div>
                        </div>

                        <div className="section-description">
                            <h3 className="section-title">Description</h3>
                            <p className="section-text">
                                Omnichannel conversational messaging for high-consideration services. Drive positive outcomes across your
                                client, candidate or patient lifecycle by leveraging AI to start conversations, guide decisions and fulfill
                                promises over messaging.
                            </p>
                        </div>

                        <div className="table-container">
                            <table className="info-table">
                                <tbody>
                                    <tr>
                                        <div className="table-row-new">
                                            <div className="table-cell">
                                                <p className="table-cell-row-heading">App Name</p>
                                                <p style={{ color: '#6B7280', fontSize: '14px' }}>{InstallPackageData.appname}</p>
                                            </div>
                                            <div className="table-cell">
                                                <p className="table-cell-row-heading">Publisher</p>
                                                <a href={InstallPackageData.publisher} rel="noreferrer" style={{ fontSize: '14px' }}>SMS Magic</a>
                                            </div>
                                            <div className="table-cell">
                                                <p className="table-cell-row-heading">Version Name</p>
                                                <p style={{ color: '#6B7280', fontSize: '14px' }}>{InstallPackageData.version}</p>
                                            </div>
                                            <div className="table-cell">
                                                <p className="table-cell-row-heading">Release Notes</p>
                                                <div style={{ display: 'flex', gap: '8px', fontSize: '14px' }}>
                                                    <span style={{ color: '#6B7280', fontSize: '14px' }}>{InstallPackageData.version}</span>
                                                    <a href={InstallPackageData.release_notes} rel="noreferrer">Release Notes</a>
                                                </div>
                                            </div>
                                        </div>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="custom-container">
                            <div className="custom-card">
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', gap: '2px' }}>
                                    <span style={{ color: 'red' }}>*</span>
                                    <h2 className="custom-header">
                                        Choose a data center
                                    </h2>
                                </div>

                                <div className="custom-center-buttons">
                                    {/* Commenting Code Below for Button as we will use Radio Button instead */}
                                    {/* {dataCenters.map((center) => (
                                        <button
                                            key={center.value}
                                            onClick={() => handleChangeDataCenter(center.value)}
                                            className={`custom-button ${dataCenter === center.value ? "custom-button-selected" : "custom-button-default"}`}
                                        >
                                            {center.name}
                                        </button>
                                    ))} */}
                                    {dataCenters.map((center) => (
                                        <label key={center.value} className="custom-radio-label">
                                            <input
                                                type="radio"
                                                name="dataCenter"
                                                value={center.value}
                                                checked={dataCenter === center.value}
                                                onChange={() => handleChangeDataCenter(center.value)}
                                                className="custom-radio"
                                            />
                                            <span className="custom-radio-span">
                                                {center.name}
                                            </span>
                                        </label>
                                    ))}
                                </div>

                                <div className="custom-checkbox-container">
                                    <div className="custom-checkbox">
                                        <input
                                            type="checkbox"
                                            id="sandbox"
                                            checked={isSandbox}
                                            onChange={handleSandboxChange}
                                            className="custom-checkbox-input"
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="sandbox" className="custom-label">
                                            Switch to Sandbox
                                        </label>
                                        <p className="custom-description">
                                            Installation will occur on your production account. Click 'Switch to Sandbox' to install it to a sandbox account.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-container">
                        <div className="footer-right">
                            <span className="footer-text">Are you a New Customer?</span>
                            <button className="footer-button"><span style={{ fontSize: '16px', fontWeight: '400' }} onClick={() => onCreateSSOURL(isSandbox ? 'sandbox' : 'production', "install")}>Install Package</span></button>
                        </div>
                        <div className="footer-left" style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }}>
                            <span className="footer-text">Are you an Existing Customer?</span>
                            <button style={{
                                border: 'none',
                                background: 'transparent',
                                color: '#0063F6',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                textUnderlineOffset: '4px',
                            }}><span style={{ fontSize: '16px', fontWeight: '400' }} onClick={() => onCreateSSOURL(isSandbox ? 'sandbox' : 'production', "upgrade")}>Upgrade Package</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

